/* eslint-disable import/prefer-default-export */

export enum ClubManagementMenuItem {
  STATISTICS = "statistics",
  USERS = "users",
  BOOKINGS = "bookings",
  RECEIPTS = "receipts",
  USER_BOOKINGS = "user_bookings",
  UNPAID_HOURS = "unpaid_hours",
}
